import React,{useCallback, useEffect, useContext} from 'react';
import ReactFlow, {
    addEdge,
    useNodesState,
    useEdgesState,
    Background,
    BackgroundVariant,
    ReactFlowProvider,
    useStoreApi,
  } from 'reactflow';
import FlowChart from '../../../components/FlowChart';
import { makeApiCall } from '../../../config';
import AuthContext from '../../../context/AuthContext';
import { successToaster } from '../../../utils/toaster';

 const FeatureFlowChart = ({nodesData, edgesData}) => {
    const [nodes, setNodes, onNodesChange] = useNodesState(nodesData);
    const [edges, setEdges, onEdgesChange] = useEdgesState(edgesData);
    const onConnect = useCallback(
        (params) => setEdges((eds) => addEdge(params, eds)),
        [setEdges],
      );

  return (
    <>{nodes.length != 0 && edges.length != 0 &&(
        <FlowChart nodes={nodes} edges={edges} onNodesChange={onNodesChange} onEdgesChange={onEdgesChange} onConnect={onConnect}/>
      )}</>
  )
}
export default ({nodesData, edgesData}) => (
    <ReactFlowProvider>
      <div style={{ width: '77vw', height: '70vh' }}>
      <FeatureFlowChart nodesData={nodesData} edgesData={edgesData} />
      </div>
    </ReactFlowProvider>
  );